"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_router_dom_1 = require("react-router-dom");
var SportsOfferForm_styles_1 = __importDefault(require("./SportsOfferForm.styles"));
var InputText_1 = __importDefault(require("../../atoms/InputText/InputText"));
var InputSelect_1 = __importDefault(require("../../atoms/InputSelect/InputSelect"));
var InputSelectMoment_1 = __importStar(require("../../atoms/InputSelectMoment/InputSelectMoment"));
var InputCheckboxes_1 = __importDefault(require("../../atoms/InputCheckboxes/InputCheckboxes"));
var InputTextarea_1 = __importDefault(require("../../atoms/InputTextarea/InputTextarea"));
var Button_1 = __importDefault(require("../../atoms/Button/Button"));
var Tooltip_1 = __importDefault(require("../../atoms/Tooltip/Tooltip"));
var loginState_1 = require("../../../types/loginState");
var InputRadio_1 = __importDefault(require("../../atoms/InputRadio/InputRadio"));
var formDataTransformations_1 = require("../../../middleware/formDataTransformations");
// These values can be retrieved from API, but for new offer will be totally empty
var newFormValues = {
    activity: { value: '' },
    sport: { value: '' },
    offer: { value: '' },
    salesforce_organisation: { value: '' },
    salesforce_contact_person: { value: '' },
    salesforce_location: { value: '' },
    days: { value: [InputSelectMoment_1.emptyDay] },
    genders: { value: [] },
    target_audience: { value: [] },
    health_impairments: { value: [] },
    movement_identities: { value: [] },
    age_bracket: { value: '' },
    membership_type: { value: '' },
    cost_bracket: { value: '' },
    cost_payed_by_time: { value: '' },
    youthfund_applicable: { value: [] },
    remarks: { value: '' },
    online_sharing_information: { value: '' },
};
// These values are for testing (prevents developer having to fill out the form everytime)
var testFormValues = {
    activity: { value: 'Testactiviteit' },
    sport: { value: 'Testsport' },
    offer: { value: 'offer' },
    salesforce_organisation: { value: '0011q000007O9F0AAK' },
    salesforce_contact_person: { value: '0031q000006CFGrAAO' },
    salesforce_location: { value: 'a001q000004XvghAAC' },
    days: {
        value: [
            {
                day: 'Maandag',
                start: '12:00',
                end: '13:00',
            },
            {
                day: 'Dinsdag',
                start: '18:00',
                end: '19:00',
            },
        ],
        error: '',
    },
    genders: { value: ['men'] },
    target_audience: { value: ['student', 'elderly'] },
    health_impairments: { value: ['various'] },
    age_bracket: { value: '6' },
    membership_type: { value: 'Lidmaatschap' },
    movement_identities: { value: ['experience'] },
    cost_payed_by_time: { value: 'monthly' },
    youthfund_applicable: { value: ['youth_fund'] },
    cost_bracket: { value: '4' },
    remarks: { value: 'Testopmerking' },
    online_sharing_information: { value: 'Testinfo' },
};
var SportsOfferForm = function (_a) {
    var loggedIn = _a.loggedIn;
    var form = react_1.useRef(null);
    var _b = react_1.useState(newFormValues), formState = _b[0], setFormState = _b[1];
    var _c = react_1.useState(true), ableToSubmit = _c[0], setAbleToSubmit = _c[1];
    var _d = react_1.useState(false), errorState = _d[0], setErrorState = _d[1];
    var _e = react_1.useState({}), responseErrors = _e[0], setResponseErrors = _e[1];
    var _f = react_1.useState(false), successState = _f[0], setSuccessState = _f[1];
    var id = react_router_dom_1.useParams().id;
    react_1.useEffect(function () {
        if (id) {
            axios_1.default
                .get("/api/activities/" + id)
                .then(function (response) {
                if (response.status < 300) {
                    setFormState(formDataTransformations_1.transformApiDataToFormData(response.data.data));
                }
            })
                .catch(function (response) {
                setErrorState(true);
            });
        }
    }, []);
    var handleSubmit = function (e) {
        // Submit can only be done if required fields are filled, so no need for extra validation
        e.preventDefault();
        setAbleToSubmit(false);
        // use method 'put' if it's an edit
        var requestMethod = id ? 'put' : 'post';
        var requestUrl = id ? "/api/activities/" + id : '/api/activities';
        axios_1.default.post(requestUrl, {
            method: requestMethod,
            data: formDataTransformations_1.transformFormDataToApi(formState),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (res) {
            setSuccessState(true);
            console.log(res);
        })
            .catch(function (error) {
            setErrorState(true);
            setResponseErrors(error.response.data.errors);
        });
    };
    react_1.useEffect(function () {
        setAbleToSubmit(true);
    }, [formState]);
    var handleInputChange = function (id, newValue) {
        setFormState(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[id] = {
                value: newValue,
                error: '',
            }, _a)));
        });
    };
    if (successState) {
        window.location.href = '/';
    }
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    return (react_1.default.createElement(SportsOfferForm_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "btn-wrapper" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/" },
                        react_1.default.createElement(Button_1.default, null,
                            react_1.default.createElement("svg", { className: "icon icon-arrow icon-left", "aria-hidden": "true" },
                                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-left" })),
                            react_1.default.createElement("span", null, "Terug")))),
                react_1.default.createElement("form", { id: "form", className: "form", onSubmit: handleSubmit, ref: form },
                    react_1.default.createElement("div", { className: "form__section form__section--intro" },
                        react_1.default.createElement("h1", { className: "title" }, id ? 'Pas aanbod aan' : 'Voeg aanbod toe'),
                        react_1.default.createElement("p", { className: "intro" },
                            "Voor meer informatie over het aanmaken van nieuw aanbod is een korte uitleg en defini\u00EBring opgesteld:",
                            ' ',
                            react_1.default.createElement("a", { href: "/dist/assets/pdf/hulpdocument.pdf", target: "_blank" }, "lees het hulpdocument"),
                            ".")),
                    react_1.default.createElement("fieldset", { className: "form__section" },
                        react_1.default.createElement("h2", { className: "section-title" },
                            "Aanbod",
                            react_1.default.createElement(Tooltip_1.default, { text: "Een activiteit staat open voor alle leden. Dit betekent dus dat de jeugdtrainingen bij het voetbal als \u00E9\u00E9n activiteit opgenomen worden." })),
                        react_1.default.createElement(InputText_1.default, __assign({ label: "Activiteit", id: "activity", required: true, placeholder: "Naam activiteit", valueChanged: handleInputChange }, formState.activity)),
                        react_1.default.createElement(InputText_1.default, __assign({ label: "Soort", id: "sport", required: true, placeholder: "Soort activiteit", valueChanged: handleInputChange }, formState.sport)),
                        react_1.default.createElement(InputSelect_1.default, __assign({}, formState.offer, { valueChanged: handleInputChange, label: "Soort aanbod", id: "offer", placeholder: "Kies de soort", options: [
                                {
                                    value: 'offer',
                                    label: 'Aanbod',
                                },
                                {
                                    value: 'existing',
                                    label: 'Bestaand',
                                },
                                {
                                    value: 'new_budget',
                                    label: 'Nieuw Budget',
                                },
                                {
                                    value: 'new_no_budget',
                                    label: 'Nieuw ZonBud',
                                },
                                {
                                    value: 'new',
                                    label: 'Nieuw',
                                },
                                {
                                    value: 'changed',
                                    label: 'Aangepast',
                                },
                                {
                                    value: 'cancelled',
                                    label: 'Opgeheven',
                                },
                            ] })),
                        react_1.default.createElement(InputText_1.default, __assign({}, formState.salesforce_organisation, { valueChanged: handleInputChange, label: "SalesForce ID organisatie", id: "salesforce_organisation", placeholder: "Organisatie SaleForce ID" })),
                        react_1.default.createElement(InputText_1.default, __assign({}, formState.salesforce_contact_person, { valueChanged: handleInputChange, label: "SalesForce ID contactpersoon", id: "salesforce_contact_person", placeholder: "Soort activiteit" })),
                        react_1.default.createElement(InputText_1.default, __assign({}, formState.salesforce_location, { valueChanged: handleInputChange, label: "SalesForce ID locatie", id: "salesforce_location", placeholder: "Locatie Salesforce ID" }))),
                    react_1.default.createElement("fieldset", { className: "form__section" },
                        react_1.default.createElement("h2", { className: "section-title" },
                            "Wanneer",
                            react_1.default.createElement(Tooltip_1.default, { text: "Geef hier aan wanneer de activiteit per week gegeven wordt. Je kan meerdere momenten aangeven." })),
                        react_1.default.createElement(InputSelectMoment_1.default, __assign({}, formState.days, { id: "days", valueChanged: handleInputChange, dayValues: {
                                label: 'Kies dag',
                                placeholder: 'Kies een dag',
                                options: [
                                    {
                                        value: 'Maandag',
                                        label: 'Maandag',
                                    },
                                    {
                                        value: 'Dinsdag',
                                        label: 'Dinsdag',
                                    },
                                    {
                                        value: 'Woensdag',
                                        label: 'Woensdag',
                                    },
                                    {
                                        value: 'Donderdag',
                                        label: 'Donderdag',
                                    },
                                    {
                                        value: 'Vrijdag',
                                        label: 'Vrijdag',
                                    },
                                    {
                                        value: 'Zaterdag',
                                        label: 'Zaterdag',
                                    },
                                    {
                                        value: 'Zondag',
                                        label: 'Zondag',
                                    },
                                ],
                            } }))),
                    react_1.default.createElement("fieldset", { className: "form__section" },
                        react_1.default.createElement("h2", { className: "section-title" },
                            "Doelgroep",
                            react_1.default.createElement(Tooltip_1.default, { text: "Geef aan voor welke doelgroep de activiteit is." })),
                        react_1.default.createElement(InputCheckboxes_1.default, __assign({}, formState.genders, { valueChanged: handleInputChange, label: "Geslacht", id: "genders", options: [
                                {
                                    value: 'mixed',
                                    label: 'Gemengd',
                                },
                                {
                                    value: 'men',
                                    label: 'Mannen',
                                },
                                {
                                    value: 'women',
                                    label: 'Vrouwen',
                                },
                            ] })),
                        react_1.default.createElement(InputText_1.default, __assign({}, formState.age_bracket, { valueChanged: handleInputChange, label: "Leeftijd", id: "age_bracket", placeholder: "Vul leeftijd in" })),
                        react_1.default.createElement(InputCheckboxes_1.default, __assign({}, formState.target_audience, { valueChanged: handleInputChange, label: "Levensfase", id: "target_audience", columns: true, options: [
                                {
                                    value: 'pregnant',
                                    label: 'Zwanger',
                                },
                                {
                                    value: 'baby',
                                    label: 'Baby (0 - 1 jaar)',
                                },
                                {
                                    value: 'preschool',
                                    label: 'Peuter (1 – 3 jaar)',
                                },
                                {
                                    value: 'toddler',
                                    label: 'Kleuter (4 - 5 jaar)',
                                },
                                {
                                    value: 'group-38',
                                    label: 'Groep (3 - 8 jaar)',
                                },
                                {
                                    value: 'teen',
                                    label: 'Puber',
                                },
                                {
                                    value: 'student',
                                    label: 'Student/ Scholier',
                                },
                                {
                                    value: 'employed',
                                    label: 'Werkend',
                                },
                                {
                                    value: 'unemployed',
                                    label: 'Werkloze',
                                },
                                {
                                    value: 'homemaker',
                                    label: 'Huisman/ huisvrouw',
                                },
                                {
                                    value: 'senior',
                                    label: 'Senior',
                                },
                                {
                                    value: 'retired',
                                    label: 'Gepensioneerde',
                                },
                                {
                                    value: 'elderly',
                                    label: 'Bejaarde',
                                },
                            ] })),
                        react_1.default.createElement(InputCheckboxes_1.default, __assign({}, formState.health_impairments, { valueChanged: handleInputChange, label: "Gezondheidsbeperkte", id: "health_impairments", columns: true, options: [
                                {
                                    value: 'hearing_impairment',
                                    label: 'Auditieve beperking',
                                },
                                {
                                    value: 'autism_spectrum',
                                    label: 'Autismespectrumstoornis',
                                },
                                {
                                    value: 'chronically_ill',
                                    label: 'Chronisch zieken',
                                },
                                {
                                    value: 'various',
                                    label: 'Diverse beperkingen',
                                },
                                {
                                    value: 'behavioral_disorder',
                                    label: 'Gedragsstoornis (ADHD, ADD, ODD etc)',
                                },
                                {
                                    value: 'physical_limitation',
                                    label: 'Lichamelijke beperking',
                                },
                                {
                                    value: 'acquired_brain_injury',
                                    label: 'Niet Aangeboren Hersenletsel',
                                },
                                {
                                    value: 'medical_rehabiliation',
                                    label: 'Revalidatie',
                                },
                                {
                                    value: 'mental_disorder',
                                    label: 'Verstandelijke beperking',
                                },
                                {
                                    value: 'visual_impairment',
                                    label: 'Visuele beperking',
                                },
                            ] })),
                        react_1.default.createElement(InputCheckboxes_1.default, __assign({}, formState.movement_identities, { valueChanged: handleInputChange, label: "Beweegidentiteit", id: "movement_identities", options: [
                                {
                                    value: 'experience',
                                    label: 'Ervaring',
                                },
                                {
                                    value: 'social',
                                    label: 'Sociaal',
                                },
                                {
                                    value: 'challenge',
                                    label: 'Uitdaging',
                                },
                            ] }))),
                    react_1.default.createElement("fieldset", { className: "form__section" },
                        react_1.default.createElement("h2", { className: "section-title" },
                            "Meedoen",
                            react_1.default.createElement(Tooltip_1.default, { text: "Geef het soort abonnement (Lidmaatschap, abonnement, strippenkaart, eenmalig) aan." })),
                        react_1.default.createElement(InputSelect_1.default, __assign({}, formState.membership_type, { valueChanged: handleInputChange, label: "Deelname mogelijkheden", id: "membership_type", placeholder: "Kies een mogelijkheid", options: [
                                {
                                    value: 'Lidmaatschap',
                                    label: 'Lidmaatschap',
                                },
                                {
                                    value: 'Abonnement',
                                    label: 'Abonnement',
                                },
                                {
                                    value: 'Strippenkaart',
                                    label: 'Strippenkaart',
                                },
                                {
                                    value: 'Eenmalig',
                                    label: 'Eenmalig',
                                },
                                {
                                    value: 'Besloten',
                                    label: 'Besloten',
                                },
                            ] })),
                        react_1.default.createElement(InputSelect_1.default, __assign({}, formState.cost_payed_by_time, { valueChanged: handleInputChange, label: "Kosten per welk periode", id: "cost_payed_by_time", placeholder: "Kies een mogelijkheid", options: [
                                {
                                    value: 'weekly',
                                    label: 'Per week',
                                },
                                {
                                    value: 'monthly',
                                    label: 'Per maand',
                                },
                                {
                                    value: 'quarterly',
                                    label: 'Per kwartaal',
                                },
                                {
                                    value: 'half_year',
                                    label: 'Per half jaar',
                                },
                                {
                                    value: 'annually',
                                    label: 'Per jaar',
                                },
                                {
                                    value: 'seasonal',
                                    label: 'Per seizoen',
                                },
                                {
                                    value: 'curcus',
                                    label: 'Per curcus',
                                },
                                {
                                    value: 'strip_card',
                                    label: 'Strippenkaart',
                                },
                                {
                                    value: 'at_a_time',
                                    label: 'Per keer',
                                },
                                {
                                    value: 'total',
                                    label: 'Totaalbedrag',
                                },
                            ] })),
                        react_1.default.createElement(InputRadio_1.default, __assign({}, formState.cost_bracket, { valueChanged: handleInputChange, label: "Kosten", id: "cost_bracket", options: [
                                {
                                    value: '1',
                                    label: '€',
                                },
                                {
                                    value: '2',
                                    label: '€€',
                                },
                                {
                                    value: '3',
                                    label: '€€€',
                                },
                                {
                                    value: '4',
                                    label: '€€€€',
                                },
                            ] }))),
                    react_1.default.createElement("fieldset", { className: "form__section" },
                        react_1.default.createElement("h2", { className: "section-title" }, "Overige informatie"),
                        react_1.default.createElement(InputCheckboxes_1.default, __assign({}, formState.youthfund_applicable, { valueChanged: handleInputChange, label: "Jeugdfonds", id: "youthfund_applicable", options: [
                                {
                                    value: 'youth_fund',
                                    label: 'Sportaanbieder is aangesloten bij het Jeugdfonds',
                                },
                            ] })),
                        react_1.default.createElement(InputTextarea_1.default, __assign({}, formState.remarks, { valueChanged: handleInputChange, id: "remarks", label: "Opmerking", labelDescription: "(200 karakters)", maxLength: 200 })),
                        react_1.default.createElement(InputTextarea_1.default, __assign({}, formState.online_sharing_information, { valueChanged: handleInputChange, id: "online_sharing_information", label: "Specifieke informatie voor online delen" })),
                        react_1.default.createElement(Button_1.default, { className: "secondary", type: "submit", disabled: !ableToSubmit },
                            react_1.default.createElement("span", null,
                                id ? 'Aanbod aanpassen' : 'Voeg aanbod toe',
                                react_1.default.createElement("svg", { className: "icon icon-arrow icon-right", "aria-hidden": "true" },
                                    react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" })))),
                        errorState && (react_1.default.createElement("div", { className: "form__error" },
                            react_1.default.createElement("p", null, "Er ging iets mis met het versturen of ophalen van het formulier"))),
                        responseErrors && (react_1.default.createElement("div", { className: "form__error" }, Object.keys(responseErrors).map(function (key) { return (react_1.default.createElement("div", { key: key },
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("b", null, key)),
                            react_1.default.createElement("ul", null, responseErrors[key].map(function (item, index) { return (react_1.default.createElement("li", { key: index }, item)); })))); })))))))));
};
exports.default = SportsOfferForm;
